import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { SessaoService } from '../../charon/services/sessao.service';

import { RegrasAcessosModulos } from '../models/regras-acessos-modulos.model';

import { isNullOrUndefined } from '../../../util/is-null-or-undefined.util';

/**
 * Serviço de permissionamento da aplicação.
 */
@Injectable()
export class PermissaoService {
  constructor(private sessao: SessaoService, private roteador: Router) {}

  /**
   * Determina se uma rota pode ser ativada ou não, de acordo com o permissionamento
   * carregado no login
   * @param next rota alvo
   * @param state rota ativa
   * @returns true ou false
   */
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Permite acesso à rota /new sem regras de permissão
    if (state?.url?.includes('/new')) {
      return true;
    }

    if (
      !isNullOrUndefined(next.data.regras) &&
      this.sessao.usuarioPossuiPermissao(
        next.data.regras as RegrasAcessosModulos
      )
    ) {
      return true;
    }

    this.roteador.navigate(['/asset/404']);
    return false;
  }
}
